import { Outlet, createFileRoute } from "@tanstack/react-router";
import { buildSeo } from "@/lib/seo";

export const Route = createFileRoute("/mybizaclia")({
  head: () =>
    buildSeo({
      title: "Mi cuenta · Bizaclia",
      description: "Gestiona tus anuncios, demandas y solicitudes en Bizaclia.",
      path: "/mybizaclia",
      noindex: true,
    }),
  component: () => <Outlet />,
});
